import type {ChangeEvent} from "react";

export function onChangeStr(onChange: (value: string) => void) {
    return (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)
}

export function onChangeNum(onChange: (value: number) => void) {
    return (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.valueAsNumber)
}